import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/ponto-apoio',
  name: 'ponto-apoio',
  component: Index,
  children: [
    { path: 'listar', name: 'ponto-apoio-listar', component: Listar },
    { path: 'novo', name: 'ponto-apoio-novo', component: Novo },
    { path: ':id', name: 'ponto-apoio-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'ponto-apoio-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/ponto-apoio/routes.js